import React, { Component } from "react"
import { Container, Row, Col } from "reactstrap"
import logo from "../images/icon/nahibu-navbar.webp"
import { withTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import i18n from 'i18next'

class NahibuFooter extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  /* Permet de remonter en haut de la page */
  backToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }

  render() {
    const t = this.props.t
    const language = i18n.language ? (i18n.language.startsWith("fr") ? "fr" : i18n.language.startsWith("en") ? "en" : 'es') : undefined
    const langSubPath = language === "en" ? "/en" : language === "es" ? "/es" : ""
    return (
      <footer className="footer bg-white my-n5 gradiant-top-gray px-3 px-md-0 small">
        <Container className="py-4">
          <Row className="align-items-start text-center text-md-start">

            {/* Colonne 1 : Logo */}
            <Col md={2} className="mt-0 mt-md-3 mb-3 mb-md-0 d-flex justify-content-center justify-content-md-start">
              <img
                src={logo}
                alt="Nahibu logo"
                style={{ height: "50px", width: "auto" }}
              />
            </Col>

            {/* Colonne 2 : Texte d'avertissement */}
            <Col md={4} xs={12} className="pt-1" style={{ color: "#7D7D7D" }}>
              <p className="small mb-1 text-left" style={{ fontSize: "12px" }}>{t("footer|Le kit Nahibu n'est pas un dispositif médical.")}</p>
              <p className="small mb-2 text-left" style={{ fontSize: "12px" }}>{t("footer|Le produit n'a pas vocation à diagnostiquer et traiter les maladies. Si vous êtes malade, consultez un professionnel de santé.")}</p>
              <p className="small mb-2 text-left" style={{ fontSize: "12px" }}>{t("footer|POUR VOTRE SANTÉ, MANGEZ AU MOINS CINQ FRUITS ET LÉGUMES PAR JOUR. www.mangerbouger.fr.")}</p>
            </Col>

            {/* Colonne 3 : Liens utiles */}
            <Col md={3} xs={6}  className="pb-2 pb-md-0 pt-1 pt-md-0">
              <p className="fw-bold mb-0">{t("footer|Liens utiles")}</p>
              <Link
                onClick={(e) => {
                  const currentPath = window.location.pathname
                  if (currentPath === langSubPath + "/" || currentPath === langSubPath) {
                    e.preventDefault()
                    this.backToTop()
                  }
                }}
                className="d-block mb-0 light-blue small"
                to={langSubPath + "/"}
              >
                {t("footer|Accueil")}
              </Link>
              <Link className="d-block mb-0 light-blue small" to={langSubPath + "/" + t("path|affilies") + "/"}>{t("footer|Affiliés Nahibu")}</Link>
              <Link  className="d-block mb-0 light-blue small" to={langSubPath + "/" + t("path|expertise-nahibu") + "/"}>{t("footer|Notre expertise")}</Link>
              <a className="d-block mb-0 light-blue small" href="https://blog.nahibu.com" target="_blank" rel="noopener noreferrer">{t("footer|Blog Nahibu")}</a>
              <a className="d-block mb-0 light-blue small" href={`https://nahibu.com/fr`} target="_blank" rel="noopener noreferrer">{t("footer|Espace Professionnels")}</a>
            </Col>

            {/* Colonne 4 : Informations légales */}
            <Col md={3} xs={6}  className="pt-1 pt-md-0">
              <p className="fw-bold mb-0">{t("footer|Informations légales")}</p>
              <Link className="d-block mb-0 light-blue small" to={langSubPath + "/" + t("path|mentions-legales") + "/"}>{t("footer|Mentions légales")}</Link>
              <Link className="d-block mb-0 light-blue small" to={langSubPath + "/" + t("path|cgv") + "/"}>{t("footer|CGV")}</Link>
              <Link className="d-block mb-0 light-blue small" to={langSubPath + "/" + t("path|politique-cookie") + "/"}>{t("footer|Cookies")}</Link>
              <Link className="d-block mb-0 light-blue small" to={langSubPath + "/" + t("path|pudp") + "/"}>{t("footer|Données personnelles")}</Link>
              <Link className="d-block mb-0 light-blue small" to={langSubPath + "/" + t("path|contact") + "/"}>{t("footer|Contact")}</Link>
            </Col>

          </Row>
        </Container>

      </footer>




    )
  }
}

export default withTranslation()(NahibuFooter)